import FormComponent from "./Components/FormComponent";
import React, {createRef} from "react";

/**
 * Class to define the message for the bot survey feedback message template.
 */
export default class BotSurveyFeedbackMessage extends FormComponent {
    /**
     * Instantiates a new instance of @type {BotSurveyFeedbackMessage}.
     */
    constructor(props) {
        super(props);

        this.questionThreeRef = createRef();
        this.toggleQuestion = this.toggleQuestion.bind(this);
    }

    /**
     * Hides the entire form input wrapper.
     * @param {HTMLElement} questionWrapper The wrapper of the radio input grouping.
     */
    hideQuestion(questionWrapper) {
        questionWrapper.classList.add('hidden');
    }

    /**
     * Hides the entire form input wrapper.
     * @param {HTMLElement} questionWrapper The wrapper of the radio input grouping.
     */
    showQuestion(questionWrapper) {
        questionWrapper.classList.remove('hidden');
    }

    /**
     * Handles the input hide/show toggle.
     * @param {InputEvent} e The event from the onchange of the controlling radio input.
     */
    toggleQuestion(e) {
        const target = e.target;
        if (!target || !this.questionThreeRef.current || !this.formRef.current || !target.dataset.controls || !target.dataset.onChange) {
            return;
        }

        const controlsTarget = this.formRef.current.querySelector(`#${this.props.payload.surveyquestions[2].value}-${this.formId}`);
        if (!controlsTarget) {
            return;
        }

        if (target.dataset.onChange === 'hide') {
            this.hideQuestion(controlsTarget);
        }
        else if (target.dataset.onChange === 'show') {
            this.showQuestion(controlsTarget);
        }
        else {
            //Do nothing
        }
    }

    /**
     * Renders out the post bot chat survey message. If the survey has been validated and submitted
     * in @type {FormComponent}, then the form will be hidden. If this template is returned in chat
     * history the form portion will also be hidden.
     */
    render() {
        if (this.props.message.isChatHistory || this.state.formSubmitted) {
            return (
                <div className={this.generateSenderClassName('bot-survey-feedback')}>
                    {this.generateSenderMessage()}
                    <div className='message-text'>
                        <div className='bot-survey-feedback__heading'>
                            {this.props.payload.heading}
                        </div>
                        <div className='bot-survey-feedback__subheading'>
                            {this.props.payload.subHeading}
                        </div>
                    </div>
                </div>
            )
        }
        return(
            <div className={this.generateSenderClassName('bot-survey-feedback')}>
                {this.generateSenderMessage()}
                <div className='bot-survey-feedback__text message-text'>
                    <div className='bot-survey-feedback__heading'>
                        {this.props.payload.heading}
                    </div>
                    <div className='bot-survey-feedback__subheading'>
                        {this.props.payload.subHeading}
                    </div>
                    <form className='bot-survey-feedback__form form' onSubmit={this.submitForm} data-submit-and-close='true' ref={this.formRef}>
                        <div className='form__input-wrapper' role='radiogroup' aria-labelledby={`question1-${this.formId}`}>
                            <div className='label' id={`question1-${this.formId}`}>
                                {this.props.payload.surveyquestions[0].question}
                            </div>
                            {this.props.payload.surveyquestions[0].values.map((radio, index) => {
                                return  <div className='radio__wrapper' key={radio}>
                                            <input type='radio'
                                                name={this.props.payload.surveyquestions[0].value}
                                                value={radio.payload}
                                                id={`${this.props.payload.surveyquestions[0].value}-${this.formId}-${index}`}
                                                className='radio__input'
                                                required/>
                                            <label htmlFor={`${this.props.payload.surveyquestions[0].value}-${this.formId}-${index}`}>{radio.title}</label>
                                        </div>
                            })}
                        </div>
                        <div className='form__input-wrapper' role='radiogroup' aria-labelledby={`question2-${this.formId}`}>
                            <div className='label' id={`question2-${this.formId}`}>
                                {this.props.payload.surveyquestions[1].question}
                            </div>
                            {this.props.payload.surveyquestions[1].values.map((radio, index) => {
                                return  <div className='radio__wrapper' key={radio}>
                                            <input type='radio'
                                                name={this.props.payload.surveyquestions[1].value}
                                                value={radio.payload}
                                                id={`${this.props.payload.surveyquestions[1].value}-${this.formId}-${index}`}
                                                className='radio__input'
                                                required
                                                onChange={(e) => this.toggleQuestion(e)}
                                                data-controls={`${this.props.payload.surveyquestions[1].controls}-${this.formId}`}
                                                data-on-change={radio.onChange}/>
                                            <label htmlFor={`${this.props.payload.surveyquestions[1].value}-${this.formId}-${index}`}>{radio.title}</label>
                                        </div>
                            })}
                        </div>
                        <div className='form__input-wrapper hidden'
                            id={`${this.props.payload.surveyquestions[2].value}-${this.formId}`}
                            role='radiogroup'
                            aria-labelledby={`question3-${this.formId}`}
                            ref={this.questionThreeRef}>
                            <div className='label' id={`question3-${this.formId}`}>
                                {this.props.payload.surveyquestions[2].question}
                            </div>
                            {this.props.payload.surveyquestions[2].values.map((radio, index) => {
                                return  <div className='radio__wrapper' key={radio}>
                                            <input type='radio'
                                                name={this.props.payload.surveyquestions[2].value}
                                                value={radio.payload}
                                                id={`${this.props.payload.surveyquestions[2].value}-${this.formId}-${index}`}
                                                className='radio__input'/>
                                            <label htmlFor={`${this.props.payload.surveyquestions[2].value}-${this.formId}-${index}`}>{radio.title}</label>
                                        </div>
                            })}
                        </div>
                        <button className='button--black' type='submit' title='Submit your feedback.'>
                            {this.props.payload.submitBtnText}
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}